import {
  useState,
  useRef,
  useCallback,
} from "react";
import { useVariant } from "../context/VariantContext";

function QaItem({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const toggle = useCallback(
    () => setIsOpen((prev) => !prev),
    [],
  );

  return (
    <div className="lp__qa-item" onClick={toggle}>
      <div className="lp__qa-item__header">
        <span className="lp__qa-item__q">Q</span>
        <span className="lp__qa-item__question">
          {question}
        </span>
        <span className="lp__qa-item__toggle">
          {isOpen ? "−" : "+"}
        </span>
      </div>
      <div
        ref={contentRef}
        className="lp__qa-item__answer"
        style={{
          maxHeight: isOpen
            ? `${contentRef.current?.scrollHeight}px`
            : "0",
        }}
      >
        <p>{answer}</p>
      </div>
    </div>
  );
}

export default function Qa() {
  const { qa } = useVariant();
  return (
    <section className="lp__qa" id="qa">
      <p className="lp__qa-en">Q&A</p>
      <h2 className="lp__qa-heading">
        よくあるご質問
      </h2>
      <div className="lp__qa-list">
        {qa.items.map((faq) => (
          <QaItem
            key={faq.question}
            question={faq.question}
            answer={faq.answer}
          />
        ))}
      </div>
    </section>
  );
}
